// extracted by mini-css-extract-plugin
export default {"fa-globe":"footer_fa-globe__wm0Ea","text_color":"footer_text_color__sSVk5","logo":"footer_logo__DYh0w"};